<template>
		<MessageBox
			class="global-message"
			transition="t-fade"
			:type="type"
			:message="message"
		>
			<template #default="{ content }">
				<div class="global-message-inner-wrapper">
					<div class="message-content">
						<span v-html="content"></span>
						<a v-if="url && url !== currentLocation.href" :href="url">{{ linkText }}</a>
					</div>

					<div v-if="showLoader" class="loader-wrapper">
						<span class="loader" />
					</div>
					<div v-else class="close-icon" @click="close" >
						<img :src="getAssetPath('cross--light.svg', 'icons')">
					</div>
				</div>
			</template>
		</MessageBox>
</template>

<script src="./GlobalMessageBox.js"></script>
